<div class="blank-frame">
  <header class="blank-window-bar" (dblclick)="toggleWindowMaximize()">
    <div class="blank-brand">
      <img class="blank-brand-logo" src="assets/images/brand/w3booster-icon-64.png" alt="W3Booster">
      <small>v{{version}}</small>
    </div>
    <div class="blank-window-controls" *ngIf="isDesktop">
      <button type="button" (click)="minimizeWindow(); $event.stopPropagation()" aria-label="Minimize"><span class="fa fa-window-minimize"></span></button>
      <button type="button" (click)="toggleWindowMaximize(); $event.stopPropagation()" [attr.aria-label]="(isMaximized || isFullScreen) ? 'Restore window' : 'Maximize window'">
        <span [class]="(isMaximized || isFullScreen) ? 'fa fa-window-restore' : 'far fa-window-maximize'"></span>
      </button>
      <button type="button" class="blank-close" (click)="closeWindow(); $event.stopPropagation()" aria-label="Close"><span class="fa fa-times"></span></button>
    </div>
  </header>
  <main class="blank-content"><router-outlet></router-outlet></main>
</div>
